function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.5,
    cy: 72.5,
    rx: 59.75,
    ry: 60.39,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,107.07A54.23,54.23,0,0,1,45,85c1.46,1.13,2.84,2.29,4.3,3.31A40.05,40.05,0,0,0,69.6,95.61,40.53,40.53,0,0,0,100,85.38a.27.27,0,0,1,.07-.08.72.72,0,0,1,1,0,55.3,55.3,0,0,1,19.21,23.39A60.54,60.54,0,0,0,132.25,72.5c0-33.35-26.75-60.39-59.75-60.39s-59.75,27-59.75,60.39a60.48,60.48,0,0,0,12.34,36.73C25.39,108.5,25.7,107.78,26,107.07ZM41.9,54.18a31.16,31.16,0,1,1,0,.32Z",
    style: {
      fill: "#9d9d9d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.75852663e80c3ad33cb772c9b96c494e.svg";
export { ForwardRef as ReactComponent };